module.exports = __webpack_public_path__ + "media/images/admin/icons/x-6c9a4ba71a333be7b021fc6da39d864c.svg";